import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import moment from 'moment'
import axios from 'axios'

const Products = ({items, setProduct}) => {

    const getItems = () => {
        return items.map((item) => {
            return (
                <div>
                    {item.name}
                    <button onClick={() => setProduct(item)}>Choisir</button>
                </div>
            )
        })
    }

    return (
        <>
            {getItems()}
        </>
    )

}

export default Products